import type { GeocoderAddressComponent } from '../../../UI/PlacesAutocomplete/PlacesAutocomplete.tsx';

export function reverseGeocodeLatLng(
  g: { Geocoder: new () => { geocode: (req: unknown, cb: (r: unknown, s: string) => void) => void } },
  lat: number,
  lng: number
): Promise<{ address: string; addressComponents?: GeocoderAddressComponent[] } | null> {
  return new Promise((resolve) => {
    try {
      const geo = new g.Geocoder();
      geo.geocode({ location: { lat, lng } }, (results: unknown, status: string) => {
        const arr = Array.isArray(results) ? results : [];
        const first = arr[0] as
          | { formatted_address?: string; address_components?: GeocoderAddressComponent[] }
          | undefined;
        if (status === 'OK' && first?.formatted_address) {
          resolve({
            address: first.formatted_address,
            addressComponents: first.address_components,
          });
        } else resolve(null);
      });
    } catch {
      resolve(null);
    }
  });
}
